export const startOfDay = (date: Date) => {
    date.setHours(0, 0, 0, 0);
    return date;
};

export const endOfDay = (date: Date) => {
    date.setHours(23, 59, 59, 999);
    return date;
};